// hier order questionnaire on Shopify (sections/hier-start.liquid). Ported from the live site's flow.js: one question
// per screen, a sessionStorage draft, Back/Forward between steps, the same validation, stops and accessibility.
// Submit: empty the cart (POST cart/clear.js), add the chosen variant with the answers as private line item properties
// (POST cart/add.js; keys starting with "_" are hidden at checkout and shown to staff on the order), then post the cart
// form to checkout. Answers that stop the order never leave the page.
(function () {
  'use strict';
  var root = document.querySelector('[data-flow]');
  if (!root) return;
  var form = root.querySelector('[data-form]');
  if (!form) return;

  var DRAFT_KEY = 'hier-start-draft-v1';
  var CONSENT_VERSION = 'consents-v3-2026-10-10'; // bump with the consent wording (start.review.consent_* keys)
  var AUTO_ADVANCE_MS = 350; // long enough to show the selection and avoid ghost taps on the next screen
  var TAP_GUARD_MS = 500; // a repeat tap on Continue this soon after it changed the screen was meant for the old screen
  var REQUEST_TIMEOUT_MS = 20000;
  var SAY_DELAY_MS = 100; // the live region is emptied first, so the same message twice is still spoken
  var UAE_OFFSET_MS = 4 * 3600 * 1000; // ages are counted on the Dubai calendar date, like the live server
  var AGE_MIN = 18;
  var AGE_MAX = 99;
  var OLDER_ADULT_AGE = 65;
  var FSI = '⁨'; // first-strong isolate: free text keeps its own direction inside a translated line
  var PDI = '⁩';
  var PLANS = ['stack3', 'month1'];
  var DEFAULT_PLAN = 'stack3';
  var PATTERNS = ['hairline', 'crown', 'diffuse', 'patchy'];
  var MULTI = ['pattern', 'previousTreatment', 'conditions'];
  var EXCLUSIVE = { conditions: 'none', previousTreatment: 'none' };
  var TEXT = ['dob', 'medications', 'notes', 'phone', 'email'];
  var RADIO = ['duration', 'sex', 'bpMeds', 'minoxidilAllergy', 'plan'];
  var CONSENTS = ['consent_accurate', 'consent_terms', 'consent_healthData', 'consent_telehealth'];
  // Same rules as the live api/_lib/validate.mjs, so nothing the live store would refuse is ordered here.
  var FORMAT_CHARS = /[­؜᠎​-‏‪-‮⁠-⁤⁦-⁩﻿]/g;
  var CONTROL_CHARS = /[\u0000-\u001F\u007F-\u009F]/g;
  var EMAIL_RE = /^[a-z0-9._%+'-]+@(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z]{2,24}$/;
  var EMAIL_MAX = 120;
  var TEXT_MAX = { medications: 500, notes: 1000 }; // live api/_lib/catalog.mjs MEDICATIONS_MAX / NOTES_MAX (= the textareas' maxlength)
  var STATUS_UNAVAILABLE = 422; // cart/add.js: sold out or not purchasable
  var STATUS_RATE = 429;

  var ds = root.dataset;
  var steps = Array.prototype.slice.call(form.querySelectorAll('[data-step]'));
  var order = steps.map(function (s) { return s.getAttribute('data-step'); });
  var nextBtn = root.querySelector('[data-next]');
  var nextLabel = root.querySelector('[data-next-label]');
  var progress = root.querySelector('[data-progress]');
  var stopEl = root.querySelector('[data-stop]');
  var alertEl = root.querySelector('[data-alert]');
  var sayEl = root.querySelector('[data-say]');
  var checkoutForm = root.querySelector('[data-checkout]');
  var listSep = (ds.listSep || ',') + ' ';
  var sayTimer = 0;
  var index = 0;
  var busy = false;
  var pushed = 0; // step entries this page added to history (back stays inside the flow)
  var rewinding = false; // history.go() is on its way to an earlier entry, which then takes the step shown
  var entry = 0; // this history entry's number: entries are numbered as they are made, so a lower one is further back
  var entryMax = 0; // the furthest step this entry has shown: once it shows an earlier one, entries before it can be further on
  var planAt = 0; // when the customer last chose the plan (Date.now(); 0 = never): the latest choice wins
  var advancing = false; // input lock during auto-advance
  var lastInput = ''; // 'pointer' or 'key': only a tap auto-advances
  var tapGuard = 0; // until then (performance.now) a tap on Continue is a repeat meant for the previous screen
  var snapshot = null; // the answers as last saved: what a restored page is reset to
  var sent = ''; // _Consents of the cart line last sent to checkout ('' = none): tells a placed order from a return
  var checking = false;

  function els(name) { return Array.prototype.slice.call(form.elements[name] instanceof RadioNodeList ? form.elements[name] : [form.elements[name]]).filter(Boolean); }
  function checkedValues(name) { return els(name).filter(function (e) { return e.checked; }).map(function (e) { return e.value; }); }
  function radioValue(name) { var v = checkedValues(name); return v.length ? v[0] : ''; }
  function textValue(name) { var e = form.elements[name]; return e ? String(e.value || '').trim() : ''; }

  function readValues() {
    var v = {};
    MULTI.forEach(function (n) { v[n] = checkedValues(n); });
    RADIO.forEach(function (n) { v[n] = radioValue(n); });
    TEXT.forEach(function (n) { v[n] = textValue(n); });
    CONSENTS.forEach(function (n) { v[n] = form.elements[n].checked; });
    return v;
  }

  function applyValues(v) {
    if (!v) return;
    MULTI.concat(RADIO).forEach(function (n) {
      var want = Array.isArray(v[n]) ? v[n] : v[n] ? [v[n]] : null;
      if (!want) return;
      els(n).forEach(function (e) { e.checked = want.indexOf(e.value) !== -1; });
    });
    TEXT.forEach(function (n) { if (typeof v[n] === 'string' && form.elements[n]) form.elements[n].value = v[n]; });
    CONSENTS.forEach(function (n) { if (typeof v[n] === 'boolean') form.elements[n].checked = v[n]; });
  }

  // The draft decides what the form shows; browsers restore old form state on Back/reload (Safari while
  // parsing, Chrome just before pageshow), which could show one plan while another is ordered.
  function sync(v) {
    form.reset();
    applyValues(v);
  }

  function save() {
    snapshot = readValues();
    try {
      sessionStorage.setItem(DRAFT_KEY, JSON.stringify({ v: snapshot, i: index, n: entry, max: entryMax, planAt: planAt, sent: sent }));
    } catch (e) { /* storage disabled: the draft is a convenience only */ }
  }

  function loadDraft() {
    try { return JSON.parse(sessionStorage.getItem(DRAFT_KEY) || 'null'); } catch (e) { return null; }
  }

  function adoptDraft(d) {
    planAt = typeof d.planAt === 'number' ? d.planAt : 0;
    sent = typeof d.sent === 'string' ? d.sent : '';
  }

  // ---------- validation ----------
  // aria-invalid goes on each control, on a radio group's container (radios cannot carry it), and for the
  // consents on the boxes still unticked.
  function setError(name, msg) {
    var el = root.querySelector('[data-err="' + name + '"]');
    if (el) el.textContent = msg || '';
    var group = root.querySelector('[data-group="' + name + '"]');
    var consents = name === 'consents';
    var targets = group ? [group] : consents ? CONSENTS.map(function (n) { return form.elements[n]; }) : els(name);
    targets.forEach(function (t) { t.setAttribute('aria-invalid', msg && !(consents && t.checked) ? 'true' : 'false'); });
  }

  function clearErrors(stepEl) {
    say('');
    Array.prototype.forEach.call(stepEl.querySelectorAll('[data-err]'), function (e) { e.textContent = ''; });
    Array.prototype.forEach.call(stepEl.querySelectorAll('[aria-invalid]'), function (e) { e.setAttribute('aria-invalid', 'false'); });
  }

  // Speaks a message through the hidden live region (for an error whose field already has focus).
  function say(msg) {
    clearTimeout(sayTimer);
    sayEl.textContent = '';
    if (msg) sayTimer = setTimeout(function () { sayEl.textContent = msg; }, SAY_DELAY_MS);
  }

  // UAE mobile: spaces, dashes, brackets and dots go; Arabic-Indic and Persian digits become ASCII; +971, 00971,
  // 0971, 971 and the trunk 0 (also after the country code) are dropped. Returns +9715XXXXXXXX or null.
  // (0971 is new: the live site refused it. What remains must still be 5 + 8 digits, so no landline gets through.)
  function normalisePhone(value) {
    var s = String(value || '').replace(FORMAT_CHARS, '').replace(/[٠-٩]/g, function (d) { return String(d.charCodeAt(0) - 0x0660); })
      .replace(/[۰-۹]/g, function (d) { return String(d.charCodeAt(0) - 0x06F0); })
      .replace(/[\s\-().]/g, '');
    if (s.charAt(0) === '+') s = s.slice(1);
    if (!/^\d+$/.test(s)) return null;
    if (s.indexOf('00971') === 0) s = s.slice(5);
    else if (s.indexOf('0971') === 0) s = s.slice(4);
    else if (s.indexOf('971') === 0) s = s.slice(3);
    if (s.charAt(0) === '0') s = s.slice(1);
    return /^5\d{8}$/.test(s) ? '+971' + s : null;
  }

  // validate.mjs cleanText: invisible marks go, control characters become spaces, spaces collapse.
  function cleanText(value) {
    return String(value || '').normalize('NFC').replace(FORMAT_CHARS, '').replace(CONTROL_CHARS, ' ').replace(/\s+/g, ' ').trim();
  }

  // validate.mjs cleanMultiline: like cleanText but keeps line breaks (at most 3 in a row).
  function cleanMultiline(value) {
    return String(value || '').normalize('NFC').replace(/\r\n?/g, '\n').replace(FORMAT_CHARS, '')
      .replace(/[\u0000-\u0009\u000B-\u001F\u007F-\u009F]/g, ' ')
      .split('\n').map(function (line) { return line.replace(/[ \t]+/g, ' ').trim(); }).join('\n')
      .replace(/\n{4,}/g, '\n\n\n').trim();
  }

  function normaliseEmail(value) {
    return cleanText(value).toLowerCase();
  }

  // Today on the Dubai calendar, read with UTC getters (validate.mjs ageFromDob does the same).
  function dubaiToday() {
    return new Date(Date.now() + UAE_OFFSET_MS);
  }

  // Accepts the native date input value (YYYY-MM-DD) or DD/MM/YYYY typed into a text fallback.
  function parseDob(value) {
    var s = String(value || '').trim().replace(/[٠-٩]/g, function (d) { return String(d.charCodeAt(0) - 0x0660); });
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s);
    var y, mo, d;
    if (m) { y = +m[1]; mo = +m[2]; d = +m[3]; } else {
      m = /^(\d{1,2})[\/.\-](\d{1,2})[\/.\-](\d{4})$/.exec(s);
      if (!m) return null;
      d = +m[1]; mo = +m[2]; y = +m[3];
    }
    var dt = new Date(Date.UTC(y, mo - 1, d));
    if (dt.getUTCFullYear() !== y || dt.getUTCMonth() !== mo - 1 || dt.getUTCDate() !== d) return null;
    var now = dubaiToday();
    if (dt.getTime() > Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate())) return null;
    var age = now.getUTCFullYear() - y;
    if (now.getUTCMonth() < mo - 1 || (now.getUTCMonth() === mo - 1 && now.getUTCDate() < d)) age -= 1;
    if (age > AGE_MAX) return null;
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    return { iso: y + '-' + pad(mo) + '-' + pad(d), age: age };
  }

  // "None" ticked together with another answer: the change handler keeps "none" exclusive, but a stored draft or a
  // future markup change could still combine them, and the live validate.mjs refuses that (multiField: conflict).
  function combinesNone(name, values) {
    return values.indexOf(EXCLUSIVE[name]) !== -1 && values.length > 1;
  }

  // Returns { ok, stop } for one step and writes inline errors. The stops are the live ones (validate.mjs hardStops:
  // not a man, under 18, minoxidil allergy); every other answer is ordered and flagged for the doctor (reviewFlags).
  // Free text over the live limits (textField: too_long, measured after cleanMultiline) is refused like the live server.
  function validateStep(key) {
    var v = readValues();
    var ok = true;
    function need(cond, name, msg) { if (!cond) { setError(name, msg || ds.errRequired); ok = false; } }
    switch (key) {
      case 'pattern': need(v.pattern.length > 0, 'pattern'); break;
      case 'duration': need(!!v.duration, 'duration'); break;
      case 'previous':
        need(v.previousTreatment.length > 0, 'previousTreatment');
        if (ok) need(!combinesNone('previousTreatment', v.previousTreatment), 'previousTreatment', ds.errConflictPrevious);
        break;
      case 'about': {
        need(!!v.sex, 'sex');
        var born = parseDob(v.dob);
        need(!!born, 'dob', ds.errDob);
        if (ok && v.sex === 'female') return { ok: false, stop: 'not_male' };
        if (ok && born.age < AGE_MIN) return { ok: false, stop: 'under_18' };
        break;
      }
      case 'conditions':
        need(v.conditions.length > 0, 'conditions');
        if (ok) need(!combinesNone('conditions', v.conditions), 'conditions', ds.errConflict);
        break;
      case 'bp': need(!!v.bpMeds, 'bpMeds'); break;
      case 'meds':
        need(!!v.minoxidilAllergy, 'minoxidilAllergy');
        if (ok && v.minoxidilAllergy === 'yes') return { ok: false, stop: 'allergy' };
        need(cleanMultiline(v.medications).length <= TEXT_MAX.medications, 'medications', ds.errTooLong);
        need(cleanMultiline(v.notes).length <= TEXT_MAX.notes, 'notes', ds.errTooLong);
        break;
      case 'contact': {
        need(!!normalisePhone(v.phone), 'phone', ds.errPhone);
        var email = normaliseEmail(v.email);
        need(email.length <= EMAIL_MAX && EMAIL_RE.test(email), 'email', ds.errEmail);
        break;
      }
      case 'review':
        need(CONSENTS.every(function (n) { return form.elements[n].checked; }), 'consents', ds.errConsent);
        break;
    }
    return { ok: ok };
  }

  // ---------- navigation ----------
  function render(i, opts) {
    index = Math.max(0, Math.min(order.length - 1, i));
    tapGuard = 0;
    say(''); // a message about another screen is not left for the screen reader to find
    stopEl.hidden = true;
    steps.forEach(function (s, n) { s.hidden = n !== index; });
    progress.style.width = Math.round(((index + 1) / order.length) * 100) + '%';
    var isReview = order[index] === 'review';
    nextLabel.textContent = isReview ? ds.labelSubmit : ds.labelNext;
    nextBtn.parentNode.parentNode.hidden = false;
    var heading = steps[index].querySelector('.flow__q');
    if (!opts || opts.focus !== false) {
      window.scrollTo(0, 0);
      if (heading) heading.focus({ preventScroll: true });
    }
    updateTotal();
    if (isReview) renderRecap();
    save();
  }

  // The visible label of a chosen option (its first text node, without the small print).
  function optionText(input) {
    var label = input.closest('label');
    var text = label && label.querySelector('.opt__text');
    return text && text.firstChild ? text.firstChild.textContent.trim() : input.value;
  }
  function picked(name) { return els(name).filter(function (e) { return e.checked; }).map(optionText).join(listSep); }
  function labelOf(selector, fallback) { var el = root.querySelector(selector); return el ? el.textContent.trim() : fallback; }

  // Read-only recap of the answers, built with textContent from the visible labels.
  function renderRecap() {
    var box = root.querySelector('[data-recap]');
    if (!box) return;
    var v = readValues();
    var born = parseDob(v.dob);
    var rows = [
      ['pattern', picked('pattern')],
      ['duration', picked('duration')],
      ['previous', picked('previousTreatment')],
      ['about', [picked('sex'), born ? '⁦' + born.iso + '⁩' : ''].filter(Boolean).join(' · ')], // LTR isolate keeps the date order in Arabic
      ['conditions', picked('conditions')],
      ['bp', picked('bpMeds')],
      ['meds', [picked('minoxidilAllergy'), v.medications ? FSI + v.medications + PDI : ''].filter(Boolean).join(' · ')],
      ['notes', v.notes, 'label[for=notes]', true], // the customer's own words, shown in their own direction
    ];
    box.textContent = '';
    rows.forEach(function (r) {
      var row = document.createElement('div');
      row.className = 'summary__row';
      var k = document.createElement('span');
      k.textContent = labelOf(r[2] || '#q-' + r[0], r[0]);
      var val = document.createElement('b');
      val.textContent = r[1] || '—';
      if (r[3]) val.dir = 'auto';
      row.appendChild(k);
      row.appendChild(val);
      box.appendChild(row);
    });
  }

  // ---------- history entries ----------
  // Each entry's state: { i: step shown, n: entry number, max: furthest step it has shown }.
  function entryState(i) {
    entryMax = Math.max(entryMax, i);
    return { i: i, n: entry, max: entryMax };
  }
  function replaceEntry(i) { history.replaceState(entryState(i), '', location.pathname + location.search); }
  function newEntry(i) {
    entry = Math.max(Date.now(), entry + 1);
    entryMax = i;
    history.pushState(entryState(i), '', location.pathname + location.search);
  }
  function entryOf(s) { return typeof s.n === 'number' ? s.n : 0; }

  // The step to show on reaching entry s from the entry the customer was on (from: its { i, n, max }, from this
  // page or the draft). Going back never goes forward: entries made before a reload or a resume in the same tab
  // can hold later steps. Back shows at most the step shown before, or the step before it once that entry had
  // gone back from a later step. -1: Back from the first question, which leaves the questionnaire.
  function arrive(s, from) {
    var i = s.i;
    if (from && typeof from.n === 'number' && typeof from.i === 'number' && typeof from.max === 'number' && entryOf(s) < from.n) {
      i = Math.min(i, from.max > from.i ? from.i - 1 : from.i);
    }
    entry = entryOf(s);
    entryMax = Math.max(typeof s.max === 'number' ? s.max : 0, s.i);
    return i;
  }

  // Back from the first question: this entry is passed over as well, on to the page before the questionnaire.
  function leave() {
    replaceEntry(0);
    render(0, { focus: false });
    history.back();
  }

  function go(i) {
    newEntry(i);
    pushed++;
    render(i);
  }

  // Back to an earlier step that needs fixing: return to its own history entry when this page added it, so the
  // next Back is never a dead press on a leftover entry of the later step. A step from before this page's first
  // entry (the page was loaded mid-flow) takes over that first entry.
  function rewindTo(i) {
    var back = Math.min(index - i, pushed);
    if (back > 0) { rewinding = true; pushed -= back; history.go(-back); }
    else replaceEntry(i);
    render(i);
  }

  function showStop(reason) {
    steps.forEach(function (s) { s.hidden = true; });
    Array.prototype.forEach.call(stopEl.querySelectorAll('[data-reason]'), function (p) { p.hidden = p.getAttribute('data-reason') !== reason; });
    stopEl.hidden = false;
    nextBtn.parentNode.parentNode.hidden = true;
    progress.style.width = '100%';
    window.scrollTo(0, 0);
    stopEl.querySelector('.flow__q').focus({ preventScroll: true });
  }

  function next() {
    if (busy) return;
    var key = order[index];
    clearErrors(steps[index]);
    var res = validateStep(key);
    if (res.stop) { showStop(res.stop); return; }
    if (!res.ok) { focusFirstError(steps[index]); return; }
    if (key === 'review') { submit(); return; }
    go(index + 1);
  }

  // The field to fix gets focus, and a screen reader reads its error with it. A field that already has focus
  // (Enter or Go pressed in it) is not read again, so its error is spoken through the live region instead.
  function focusFirstError(stepEl) {
    var err = Array.prototype.find.call(stepEl.querySelectorAll('[data-err]'), function (e) { return e.textContent; });
    if (!err) return;
    var input;
    if (err.getAttribute('data-err') === 'consents') {
      input = CONSENTS.map(function (n) { return form.elements[n]; }).filter(function (b) { return !b.checked; })[0];
      // The message moves right above the first box to tick and comes up under the header, with that box under
      // it: both are on screen even on a small phone where the four boxes do not fit.
      var label = input && input.closest('label');
      if (label) { label.parentNode.insertBefore(err, label); err.scrollIntoView({ block: 'start' }); }
    } else {
      var field = err.closest('.field, fieldset, .flow__step');
      input = field && field.querySelector('input:not([type=hidden]), select, textarea');
    }
    if (!input) return;
    if (input === document.activeElement) say(err.textContent);
    else input.focus({ preventScroll: err.getAttribute('data-err') === 'consents' });
  }

  // ---------- exclusive "none" + auto-advance ----------
  form.addEventListener('change', function (e) {
    var t = e.target;
    var none = EXCLUSIVE[t.name];
    if (none && t.checked) {
      els(t.name).forEach(function (o) {
        if (t.value === none ? o !== t : o.value === none) o.checked = false;
      });
    }
    if (t.name === 'plan') { planAt = Date.now(); updateTotal(); }
    // Only this answer's error goes; the other fields keep theirs until they are fixed. A consent message stays
    // until every box is ticked, and only the boxes still unticked stay marked invalid.
    if (CONSENTS.indexOf(t.name) === -1) setError(t.name, '');
    else setError('consents', CONSENTS.every(function (n) { return form.elements[n].checked; }) ? '' : root.querySelector('[data-err="consents"]').textContent);
    tapGuard = 0;
    save();
  });
  form.addEventListener('pointerdown', function () { lastInput = 'pointer'; tapGuard = 0; }, true);
  form.addEventListener('keydown', function () { lastInput = 'key'; tapGuard = 0; }, true);
  // Single-choice questions advance on tap — including re-tapping the answer already chosen. Arrow keys only
  // move the selection (WCAG 3.2.2); keyboard users continue with Enter or the button.
  form.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.matches || !t.matches('input[data-auto]')) return;
    if (lastInput !== 'pointer') return;
    if (advancing) { e.preventDefault(); return; }
    advancing = true;
    setTimeout(function () {
      advancing = false;
      if (t.checked && !steps[index].hidden && steps[index].contains(t)) next();
    }, AUTO_ADVANCE_MS);
  });
  form.addEventListener('input', function () { tapGuard = 0; save(); });
  form.addEventListener('submit', function (e) { e.preventDefault(); next(); });
  // Enter in a text field or a single-choice question advances instead of submitting the whole form.
  form.addEventListener('keydown', function (e) {
    var t = e.target;
    if (e.key !== 'Enter' || t.tagName !== 'INPUT') return;
    if ((t.type !== 'checkbox' && t.type !== 'radio') || t.matches('input[data-auto]')) { e.preventDefault(); next(); }
  });

  function chosenPlan() { return els('plan').filter(function (e) { return e.checked; })[0] || null; }

  function updateTotal() {
    var plan = chosenPlan();
    var total = root.querySelector('[data-total]');
    if (plan && total) total.textContent = plan.getAttribute('data-amount');
  }

  // A quick second or third tap on Continue lands on the screen the first tap opened (it could even submit the
  // order from a review screen seen for a split second): ignore it until the customer touches that screen.
  nextBtn.addEventListener('click', function () {
    var now = performance.now();
    if (now < tapGuard) { tapGuard = now + TAP_GUARD_MS; return; }
    var from = index;
    next();
    if (index !== from) tapGuard = now + TAP_GUARD_MS;
  });
  root.querySelector('[data-back]').addEventListener('click', function () {
    if (busy) return; // the answers on screen are on their way to the cart
    if (!stopEl.hidden) { render(index); return; }
    if (pushed > 0) history.back();
    else if (index > 0) { replaceEntry(index - 1); render(index - 1); }
    else location.href = ds.home;
  });
  root.querySelector('[data-unstop]').addEventListener('click', function () { render(index); });
  window.addEventListener('popstate', function (e) {
    if (!e.state || typeof e.state.i !== 'number') return; // a #fragment entry, not a step
    if (rewinding) { rewinding = false; arrive(e.state, null); replaceEntry(index); save(); return; } // see rewindTo
    if (busy) { newEntry(index); return; } // stay on the sent answers
    pushed = Math.max(0, pushed - 1);
    var i = arrive(e.state, { i: index, n: entry, max: entryMax });
    if (i < 0) { leave(); return; }
    if (i !== e.state.i) replaceEntry(i);
    if (i !== index || !stopEl.hidden) render(i);
  });
  // "Skip to content" jumps to the current question; a #main history entry would read as "back to step 1".
  var skip = document.querySelector('a.skip');
  if (skip) skip.addEventListener('click', function (e) {
    e.preventDefault();
    (stopEl.hidden ? steps[index] : stopEl).querySelector('.flow__q').focus();
  });

  // ---------- the order line ----------
  // Items the reviewing doctor should look at first: the live api/_lib/handlers.mjs reviewFlags, unchanged.
  function reviewFlags(v, age) {
    var flags = v.conditions.filter(function (c) { return c !== 'none'; }).map(function (c) { return 'condition:' + c; });
    if (v.bpMeds === 'yes') flags.push('takes_bp_medication');
    if (age >= OLDER_ADULT_AGE) flags.push('age_65_plus');
    if (v.pattern.indexOf('patchy') !== -1) flags.push('patchy_loss_check_alopecia_areata');
    if (v.previousTreatment.indexOf('oral_minoxidil') !== -1) flags.push('previous_oral_minoxidil');
    if (cleanMultiline(v.medications)) flags.push('lists_medications');
    if (cleanMultiline(v.notes)) flags.push('customer_notes');
    return flags;
  }

  // One line per question, "question: answer", in the language of the page (the labels on screen). Free text keeps
  // the customer's words on one line ("/" between their lines).
  function questionnaireText(v, born, phone, email, plan) {
    var free = function (s) { return cleanMultiline(s).split('\n').filter(Boolean).join(' / ') || '—'; };
    var planName = plan.closest('label').querySelector('.plan__name');
    var lines = [
      [labelOf('#q-pattern'), picked('pattern')],
      [labelOf('#q-duration'), picked('duration')],
      [labelOf('#q-previous'), picked('previousTreatment')],
      [labelOf('#sex-label'), picked('sex')],
      [labelOf('label[for=dob]'), born.iso],
      [labelOf('#q-conditions'), picked('conditions')],
      [labelOf('#q-bp'), picked('bpMeds')],
      [labelOf('#minoxidilAllergy-label'), picked('minoxidilAllergy')],
      [labelOf('label[for=medications]'), free(v.medications)],
      [labelOf('label[for=notes]'), free(v.notes)],
      [labelOf('label[for=phone]'), phone],
      [labelOf('label[for=email]'), email],
      [labelOf('.review__h'), planName ? planName.textContent.trim() : plan.value],
    ];
    return lines.map(function (l) { return l[0] + ': ' + l[1]; }).join('\n');
  }

  function lineItem(plan) {
    var v = readValues();
    var born = parseDob(v.dob);
    var phone = normalisePhone(v.phone);
    var email = normaliseEmail(v.email);
    var flags = reviewFlags(v, born.age);
    return {
      id: Number(plan.getAttribute('data-variant')),
      quantity: 1,
      properties: {
        _Questionnaire: questionnaireText(v, born, phone, email, plan),
        _Flags: flags.length ? flags.join(', ') : 'none',
        _Consents: CONSENT_VERSION + '; accurate, terms, healthData, telehealth; ' + new Date().toISOString(),
        _Mobile: phone,
        _Email: email,
        _Lang: ds.lang,
      },
    };
  }

  // ---------- submit ----------
  function showAlert(msg) {
    alertEl.textContent = msg;
    alertEl.hidden = !msg;
    if (msg) alertEl.scrollIntoView({ block: 'center' });
  }

  // While the order is on its way the answers on screen are the answers sent: nothing can be changed (inert;
  // browsers without it get every control disabled), and Back stays put (see popstate).
  function setBusy(on) {
    busy = on;
    nextBtn.disabled = on;
    nextBtn.setAttribute('aria-busy', on ? 'true' : 'false');
    nextLabel.textContent = on ? '…' : order[index] === 'review' ? ds.labelSubmit : ds.labelNext;
    if ('inert' in form) form.inert = on;
    else Array.prototype.forEach.call(form.elements, function (el) { el.disabled = on; });
  }

  function validateAll() {
    for (var i = 0; i < order.length; i++) {
      clearErrors(steps[i]);
      var res = validateStep(order[i]);
      if (res.stop) { showStop(res.stop); return false; }
      if (!res.ok) { rewindTo(i); focusFirstError(steps[i]); return false; }
    }
    return true;
  }

  // fetch with a time limit; resolves with the JSON body, rejects with an Error carrying .status (0 = no answer).
  function request(method, url, body) {
    var controller = new AbortController();
    var timer = setTimeout(function () { controller.abort(); }, REQUEST_TIMEOUT_MS);
    var init = { method: method, headers: { Accept: 'application/json' }, credentials: 'same-origin', signal: controller.signal };
    if (body !== undefined) {
      init.headers['Content-Type'] = 'application/json';
      init.body = JSON.stringify(body);
    }
    return fetch(url, init).then(function (res) {
      clearTimeout(timer);
      if (!res.ok) { var failed = new Error('HTTP ' + res.status + ' from ' + url); failed.status = res.status; throw failed; }
      return res.json();
    }, function (cause) {
      clearTimeout(timer);
      var lost = new Error('no answer from ' + url + ': ' + (cause && cause.message));
      lost.status = 0;
      throw lost;
    });
  }

  function failureMessage(error) {
    if (error.status === STATUS_UNAVAILABLE) return ds.subUnavailable;
    if (error.status === STATUS_RATE) return ds.subRate;
    if (error.status === 0) return ds.subNetwork;
    return ds.subServer;
  }

  function submit() {
    if (!validateAll()) return;
    if (!chosenPlan()) applyValues({ plan: DEFAULT_PLAN }); // the page always shows a plan; never order none
    // The amount on screen is the amount ordered: if the shown total was stale, show the real one first.
    var total = root.querySelector('[data-total]');
    var shown = total.textContent;
    updateTotal();
    if (total.textContent !== shown) { total.scrollIntoView({ block: 'center' }); return; }
    var item = lineItem(chosenPlan());
    showAlert('');
    setBusy(true);
    // Clearing first makes the cart exactly this one line, however often the customer submits or comes back.
    request('POST', ds.cartClear + '.js', {})
      .then(function () { return request('POST', ds.cartAdd + '.js', { items: [item] }); })
      .then(function () {
        sent = item.properties._Consents;
        save();
        checkoutForm.submit();
      })
      .catch(function (error) {
        setBusy(false);
        showAlert(failureMessage(error));
      });
  }

  // Back from checkout can bring this page back (bfcache, or a reload the browser refills). If the line sent to
  // checkout is no longer in the cart, the order was placed (Shopify empties the cart) or the cart was changed: the
  // answers are cleared from this device and the questionnaire starts over. If the cart cannot be read, they stay.
  function startOver() {
    sent = '';
    planAt = 0;
    form.reset();
    applyValues({ plan: DEFAULT_PLAN });
    setBusy(false);
    showAlert('');
    pushed = 0;
    replaceEntry(0); // keeps the furthest step, so Back from here leaves instead of reopening a later step
    render(0, { focus: false }); // also overwrites the stored draft
  }

  function checkSent() {
    if (!sent || checking) return;
    var stamp = sent;
    checking = true;
    request('GET', ds.cart + '.js').then(function (cart) {
      checking = false;
      if (busy || stamp !== sent) return; // a newer submission took over meanwhile
      var items = cart && Array.isArray(cart.items) ? cart.items : [];
      var inCart = items.some(function (it) { return it && it.properties && it.properties._Consents === stamp; });
      if (!inCart) startOver();
    }, function () { checking = false; });
  }

  window.addEventListener('pageshow', function (e) {
    var stored = loadDraft();
    sync(stored && stored.v ? stored.v : snapshot);
    if (stored) adoptDraft(stored);
    if (e.persisted) { setBusy(false); showAlert(''); }
    if (!stopEl.hidden) return;
    var i = index;
    // Restored by Back from a later entry (another load of the questionnaire): the same rule as Back in the page.
    if (e.persisted && history.state && typeof history.state.i === 'number') {
      i = arrive(history.state, stored);
      if (i < 0) { leave(); return; }
      if (i !== history.state.i) replaceEntry(i);
    }
    render(i, { focus: false });
    if (e.persisted) checkSent();
  });

  // ---------- boot ----------
  var params = new URLSearchParams(location.search);
  var draft = loadDraft();
  sync(draft && draft.v ? draft.v : {});
  if (draft) adoptDraft(draft);
  // Only a plan the customer picked on the home page comes as ?plan=. A start link may carry when it was picked
  // (?picked=): it applies unless the customer chose a plan since, so a page brought back by Back with an older pick
  // never overrides a later choice. The plan button names its plan and sends no time: chosen now.
  var qp = params.get('plan');
  var qPicked = params.get('picked');
  if (PLANS.indexOf(qp) !== -1) {
    var pickedAt = qPicked === null ? Date.now() : Math.min(Math.max(0, Number(qPicked) || 0), Date.now());
    if (qPicked === null || pickedAt >= planAt) { applyValues({ plan: qp }); planAt = pickedAt; }
  }
  if (!radioValue('plan')) applyValues({ plan: DEFAULT_PLAN });
  var qPattern = params.get('pattern');
  if (qPattern && PATTERNS.indexOf(qPattern) !== -1 && !(draft && draft.v && draft.v.pattern && draft.v.pattern.length)) {
    applyValues({ pattern: [qPattern] });
  }
  var start = 0;
  var here = history.state && typeof history.state.i === 'number' ? history.state : null; // a reload, Back or Forward
  if (here) {
    var arrived = arrive(here, draft);
    if (draft) start = arrived;
  } else {
    entry = Math.max(Date.now(), (draft && typeof draft.n === 'number' ? draft.n : 0) + 1); // a new entry
    if (draft && typeof draft.i === 'number') start = draft.i;
  }
  var leaving = start < 0; // Back from the first question
  if (leaving) start = 0;
  // The query seeds this visit only; a reload or Back must never re-apply it over the customer's answers.
  ['plan', 'picked', 'pattern'].forEach(function (k) { params.delete(k); });
  var query = params.toString();
  history.replaceState(entryState(start), '', location.pathname + (query ? '?' + query : ''));
  render(start, { focus: false });
  if (leaving) history.back();
  else checkSent();

  var dobInput = form.elements.dob;
  if (dobInput) dobInput.max = dubaiToday().toISOString().slice(0, 10);
  var langLink = root.querySelector('.flow__bar .lang');
  if (langLink) langLink.addEventListener('click', function () { save(); });
})();
